import { render, staticRenderFns } from "./Imofalform3itemsForm.vue?vue&type=template&id=b2b9bd7e"
import script from "./Imofalform3itemsForm.vue?vue&type=script&lang=js"
export * from "./Imofalform3itemsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports